import React from 'react';
// import ChiTieuTuyenSinhPivotGrid from '../../components/report/chi-tieu-tuyen-sinh';
import ProcessDashboard from '../process-dashboard/ProcessDashboard';
// import TongHop from '../sf_mucphaithu_tonghop/TongHop';

import './home.scss';
export default () => {


  return (
    <div>
      {/* <ImportPhanLopModal /> */}
      {/* <ChiTieuTuyenSinhPivotGrid /> */}
      <ProcessDashboard />
      {/* <TongHop/> */}
    </div>
  );
}
